msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: pt\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-08-31 00:56\n"
"Last-Translator: \n"
"Language-Team: Portuguese, Brazilian\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: pt-BR\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:133
msgid "Locked"
msgstr "Bloqueado"

#: src/components/account-block.jsx:139
msgid "Posts: {0}"
msgstr "Publicações: {0}"

#: src/components/account-block.jsx:144
msgid "Last posted: {0}"
msgstr "Última publicação: {0}"

#: src/components/account-block.jsx:159
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Automatizado"

#: src/components/account-block.jsx:166
#: src/components/account-info.jsx:639
#: src/components/status.jsx:439
#: src/pages/catchup.jsx:1454
msgid "Group"
msgstr "Grupo"

#: src/components/account-block.jsx:176
msgid "Mutual"
msgstr "Mutuo"

#: src/components/account-block.jsx:180
#: src/components/account-info.jsx:1674
msgid "Requested"
msgstr "Solicitado"

#: src/components/account-block.jsx:184
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:756
#: src/components/account-info.jsx:1665
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:137
#: src/pages/following.jsx:20
#: src/pages/following.jsx:131
msgid "Following"
msgstr "Seguindo"

#: src/components/account-block.jsx:188
#: src/components/account-info.jsx:1059
msgid "Follows you"
msgstr "Segue você"

#: src/components/account-block.jsx:196
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# seguidor} other {# seguidores}}"

#: src/components/account-block.jsx:205
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Verificado"

#: src/components/account-block.jsx:220
#: src/components/account-info.jsx:777
msgid "Joined <0>{0}</0>"
msgstr "Entrou em <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Para sempre"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Não foi possível carregar a conta."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Ir à página da conta"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Seguidores"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:773
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Publicações"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1115
#: src/components/compose.jsx:2451
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1635
#: src/components/status.jsx:1652
#: src/components/status.jsx:1776
#: src/components/status.jsx:2371
#: src/components/status.jsx:2374
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1169
#: src/pages/trending.jsx:437
msgid "More"
msgstr "Mais"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> indicou que a nova conta é:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1273
msgid "Handle copied"
msgstr "Identificador copiado"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1276
msgid "Unable to copy handle"
msgstr "Não foi possível copiar o identificador"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1282
msgid "Copy handle"
msgstr "Copiar identificador"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Ir à página do perfil original"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Ver foto de perfil"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Ver cabeçalho do perfil"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "Em memória"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:747
msgid "This user has chosen to not make this information available."
msgstr "Este usuário decidiu não fazer essa informação disponível."

#: src/components/account-info.jsx:802
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} publicações originais, {1} respostas, {2} impulsos"

#: src/components/account-info.jsx:818
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Última publicação no último 1 dia} other {Última publicação nos últimos {2} dias}}} other {{3, plural, one {Últimas {4} publicações no último 1 dia} other {Últimas {5} publicações nos últimos {6} dias}}}}"

#: src/components/account-info.jsx:831
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Última publicação no(s) ano(s) passado(s)} other {Últimas {1} publicações no(s) ano(s) passado(s)}}"

#: src/components/account-info.jsx:855
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Original"

#: src/components/account-info.jsx:859
#: src/components/status.jsx:2162
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1428
#: src/pages/catchup.jsx:2039
#: src/pages/status.jsx:892
#: src/pages/status.jsx:1494
msgid "Replies"
msgstr "Respostas"

#: src/components/account-info.jsx:863
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1430
#: src/pages/catchup.jsx:2051
#: src/pages/settings.jsx:1028
msgid "Boosts"
msgstr "Impulsos"

#: src/components/account-info.jsx:869
msgid "Post stats unavailable."
msgstr "As estatísticas da publicação estão indisponíveis."

#: src/components/account-info.jsx:900
msgid "View post stats"
msgstr "Ver estatísticas da publicação"

#: src/components/account-info.jsx:1063
msgid "Last post: <0>{0}</0>"
msgstr "Última publicação: <0>{0}</0>"

#: src/components/account-info.jsx:1077
msgid "Muted"
msgstr "Silenciado"

#: src/components/account-info.jsx:1082
msgid "Blocked"
msgstr "Bloqueado"

#: src/components/account-info.jsx:1091
msgid "Private note"
msgstr "Nota privada"

#: src/components/account-info.jsx:1148
msgid "Mention <0>@{username}</0>"
msgstr "Mencionar <0>@{username}</0>"

#: src/components/account-info.jsx:1160
msgid "Translate bio"
msgstr "Traduzir biografia"

#: src/components/account-info.jsx:1171
msgid "Edit private note"
msgstr "Editar nota privada"

#: src/components/account-info.jsx:1171
msgid "Add private note"
msgstr "Adicionar nota privada"

#: src/components/account-info.jsx:1191
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notificações ativadas para as publicações de @{username}."

#: src/components/account-info.jsx:1192
msgid "Notifications disabled for @{username}'s posts."
msgstr "Notificações desativadas para as publicações de @{username}."

#: src/components/account-info.jsx:1204
msgid "Disable notifications"
msgstr "Desativar notificações"

#: src/components/account-info.jsx:1205
msgid "Enable notifications"
msgstr "Ativar notificações"

#: src/components/account-info.jsx:1222
msgid "Boosts from @{username} enabled."
msgstr "Impulsos de @{username} ativados."

#: src/components/account-info.jsx:1223
msgid "Boosts from @{username} disabled."
msgstr "Impulsos de @{username} desativados."

#: src/components/account-info.jsx:1234
msgid "Disable boosts"
msgstr "Desativar impulsos"

#: src/components/account-info.jsx:1234
msgid "Enable boosts"
msgstr "Ativar impulsos"

#: src/components/account-info.jsx:1250
#: src/components/account-info.jsx:1260
#: src/components/account-info.jsx:1858
msgid "Add/Remove from Lists"
msgstr "Adicionar/Remover das listas"

#: src/components/account-info.jsx:1299
#: src/components/status.jsx:1078
msgid "Link copied"
msgstr "Link copiado"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1081
msgid "Unable to copy link"
msgstr "Não foi possível copiar link"

#: src/components/account-info.jsx:1308
#: src/components/shortcuts-settings.jsx:1056
#: src/components/status.jsx:1087
#: src/components/status.jsx:3109
msgid "Copy"
msgstr "Copiar"

#: src/components/account-info.jsx:1323
#: src/components/shortcuts-settings.jsx:1074
#: src/components/status.jsx:1103
msgid "Sharing doesn't seem to work."
msgstr "Compartilhar não parece estar funcionando."

#: src/components/account-info.jsx:1329
#: src/components/status.jsx:1109
msgid "Share…"
msgstr "Compartilhar…"

#: src/components/account-info.jsx:1349
msgid "Unmuted @{username}"
msgstr "Dessilenciou @{username}"

#: src/components/account-info.jsx:1361
msgid "Unmute <0>@{username}</0>"
msgstr "Dessilenciar <0>@{username}</0>"

#: src/components/account-info.jsx:1377
msgid "Mute <0>@{username}</0>…"
msgstr "Silenciar <0>@{username}</0>…"

#: src/components/account-info.jsx:1409
msgid "Muted @{username} for {0}"
msgstr "Silenciou @{username} por {0}"

#: src/components/account-info.jsx:1421
msgid "Unable to mute @{username}"
msgstr "Não foi possível silenciar @{username}"

#: src/components/account-info.jsx:1442
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Excluir <0>@{username}</0> dos seguidores?"

#: src/components/account-info.jsx:1462
msgid "@{username} removed from followers"
msgstr "@{username} excluido dos seguidores"

#: src/components/account-info.jsx:1474
msgid "Remove follower…"
msgstr "Excluir seguidor…"

#: src/components/account-info.jsx:1485
msgid "Block <0>@{username}</0>?"
msgstr "Bloquear <0>@{username}</0>?"

#: src/components/account-info.jsx:1506
msgid "Unblocked @{username}"
msgstr "Desbloqueou @{username}"

#: src/components/account-info.jsx:1514
msgid "Blocked @{username}"
msgstr "Bloqueou @{username}"

#: src/components/account-info.jsx:1522
msgid "Unable to unblock @{username}"
msgstr "Não foi possível desbloquear @{username}"

#: src/components/account-info.jsx:1524
msgid "Unable to block @{username}"
msgstr "Não foi possível bloquear @{username}"

#: src/components/account-info.jsx:1534
msgid "Unblock <0>@{username}</0>"
msgstr "Desbloquear <0>@{username}</0>"

#: src/components/account-info.jsx:1543
msgid "Block <0>@{username}</0>…"
msgstr "Bloquear <0>@{username}</0>…"

#: src/components/account-info.jsx:1560
msgid "Report <0>@{username}</0>…"
msgstr "Denunciar <0>@{username}</0>…"

#: src/components/account-info.jsx:1580
#: src/components/account-info.jsx:2091
msgid "Edit profile"
msgstr "Editar perfil"

#: src/components/account-info.jsx:1616
msgid "Withdraw follow request?"
msgstr "Excluir solicitação de seguimento?"

#: src/components/account-info.jsx:1617
msgid "Unfollow @{0}?"
msgstr "Parar de seguir @{0}?"

#: src/components/account-info.jsx:1668
msgid "Unfollow…"
msgstr "Parar de seguir…"

#: src/components/account-info.jsx:1677
msgid "Withdraw…"
msgstr "Excluir…"

#: src/components/account-info.jsx:1684
#: src/components/account-info.jsx:1688
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Seguir"

#: src/components/account-info.jsx:1799
#: src/components/account-info.jsx:1853
#: src/components/account-info.jsx:1986
#: src/components/account-info.jsx:2086
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:797
#: src/components/compose.jsx:2407
#: src/components/compose.jsx:2880
#: src/components/compose.jsx:3088
#: src/components/compose.jsx:3318
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:227
#: src/components/shortcuts-settings.jsx:580
#: src/components/shortcuts-settings.jsx:780
#: src/components/status.jsx:2834
#: src/components/status.jsx:3073
#: src/components/status.jsx:3571
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1564
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:840
#: src/pages/notifications.jsx:1054
#: src/pages/settings.jsx:69
#: src/pages/status.jsx:1256
msgid "Close"
msgstr "Fechar"

#: src/components/account-info.jsx:1804
msgid "Translated Bio"
msgstr "Biografia traduzida"

#: src/components/account-info.jsx:1898
msgid "Unable to remove from list."
msgstr "Não foi possível remover da lista."

#: src/components/account-info.jsx:1899
msgid "Unable to add to list."
msgstr "Não foi possível adicionar à lista."

#: src/components/account-info.jsx:1918
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Não foi possível carregar listas."

#: src/components/account-info.jsx:1922
msgid "No lists."
msgstr "Sem listas."

#: src/components/account-info.jsx:1933
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nova lista"

#: src/components/account-info.jsx:1991
msgid "Private note about <0>@{0}</0>"
msgstr "Nota privada sobre <0>@{0}</0>"

#: src/components/account-info.jsx:2021
msgid "Unable to update private note."
msgstr "Não foi possível atualizar nota privada."

#: src/components/account-info.jsx:2044
#: src/components/account-info.jsx:2214
msgid "Cancel"
msgstr "Cancelar"

#: src/components/account-info.jsx:2049
msgid "Save & close"
msgstr "Salvar e fechar"

#: src/components/account-info.jsx:2142
msgid "Unable to update profile."
msgstr "Não foi possível atualizar perfil."

#: src/components/account-info.jsx:2162
msgid "Bio"
msgstr "Biografia"

#: src/components/account-info.jsx:2175
msgid "Extra fields"
msgstr "Campos adicionais"

#: src/components/account-info.jsx:2181
msgid "Label"
msgstr "Etiqueta"

#: src/components/account-info.jsx:2184
msgid "Content"
msgstr "Conteúdo"

#: src/components/account-info.jsx:2217
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:712
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:906
msgid "Save"
msgstr "Salvar"

#: src/components/account-info.jsx:2270
msgid "username"
msgstr "nome de usuário"

#: src/components/account-info.jsx:2274
msgid "server domain name"
msgstr "nome de domínio do servidor"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Modo oculto desativado"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Modo oculto ativado"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:137
#: src/components/timeline.jsx:434
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:52
#: src/pages/notifications.jsx:505
msgid "Home"
msgstr "Início"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Escrever"

#: src/components/compose.jsx:392
msgid "You have unsaved changes. Discard this post?"
msgstr "Você tem mudanças não salvas. Descartar publicação?"

#: src/components/compose.jsx:614
#: src/components/compose.jsx:630
#: src/components/compose.jsx:1328
#: src/components/compose.jsx:1589
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural,one {Você só pode anexar até 1 arquivo.} other {Você só pode anexar até # arquivos.}}"

#: src/components/compose.jsx:778
msgid "Pop out"
msgstr "Fechar"

#: src/components/compose.jsx:785
msgid "Minimize"
msgstr "Minimizar"

#: src/components/compose.jsx:821
msgid "Looks like you closed the parent window."
msgstr "Parece que você fechou a janela principal."

#: src/components/compose.jsx:828
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Parece que você já tem um campo de edição aberta na janela principal e atualmente está publicando. Espere até terminar e tente novamente mais tarde."

#: src/components/compose.jsx:833
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Parece que você já tem um campo de edição aberta na janela principal. Abrir esta janela irá desfazer as mudanças que você fez na janela principal. Continuar?"

#: src/components/compose.jsx:875
msgid "Pop in"
msgstr "Abrir"

#: src/components/compose.jsx:885
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Respondendo à publicação de @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:895
msgid "Replying to @{0}’s post"
msgstr "Respondendo à publicação de @{0}"

#: src/components/compose.jsx:908
msgid "Editing source post"
msgstr "Editando publicação original"

#: src/components/compose.jsx:955
msgid "Poll must have at least 2 options"
msgstr "A enquete deve ter no mínimo 2 opções"

#: src/components/compose.jsx:959
msgid "Some poll choices are empty"
msgstr "Algumas opções da enquete estão vazias"

#: src/components/compose.jsx:972
msgid "Some media have no descriptions. Continue?"
msgstr "Algumas mídias não têm descrição. Continuar?"

#: src/components/compose.jsx:1024
msgid "Attachment #{i} failed"
msgstr "Anexo #{i} falhou"

#: src/components/compose.jsx:1118
#: src/components/status.jsx:1961
#: src/components/timeline.jsx:978
msgid "Content warning"
msgstr "Aviso de conteúdo"

#: src/components/compose.jsx:1134
msgid "Content warning or sensitive media"
msgstr "Aviso de conteúdo ou mídia sensível"

#: src/components/compose.jsx:1170
#: src/components/status.jsx:93
#: src/pages/settings.jsx:297
msgid "Public"
msgstr "Público"

#: src/components/compose.jsx:1173
#: src/components/status.jsx:94
#: src/pages/settings.jsx:300
msgid "Unlisted"
msgstr "Não listado"

#: src/components/compose.jsx:1176
#: src/components/status.jsx:95
#: src/pages/settings.jsx:303
msgid "Followers only"
msgstr "Apenas seguidores"

#: src/components/compose.jsx:1179
#: src/components/status.jsx:96
#: src/components/status.jsx:1839
msgid "Private mention"
msgstr "Menção privada"

#: src/components/compose.jsx:1188
msgid "Post your reply"
msgstr "Publicar resposta"

#: src/components/compose.jsx:1190
msgid "Edit your post"
msgstr "Editar publicação"

#: src/components/compose.jsx:1191
msgid "What are you doing?"
msgstr "O que está fazendo?"

#: src/components/compose.jsx:1266
msgid "Mark media as sensitive"
msgstr "Marcar mídia como sensível"

#: src/components/compose.jsx:1364
msgid "Add poll"
msgstr "Adicionar enquete"

#: src/components/compose.jsx:1386
msgid "Add custom emoji"
msgstr "Adicionar emoji personalizado"

#: src/components/compose.jsx:1470
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:830
#: src/components/status.jsx:1615
#: src/components/status.jsx:1616
#: src/components/status.jsx:2267
msgid "Reply"
msgstr "Responder"

#: src/components/compose.jsx:1472
msgid "Update"
msgstr "Atualizar"

#: src/components/compose.jsx:1473
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Publicar"

#: src/components/compose.jsx:1601
msgid "Downloading GIF…"
msgstr "Baixando GIF…"

#: src/components/compose.jsx:1629
msgid "Failed to download GIF"
msgstr "Falhou ao baixar GIF"

#: src/components/compose.jsx:1740
#: src/components/compose.jsx:1817
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Mais…"

#: src/components/compose.jsx:2220
msgid "Uploaded"
msgstr "Enviado"

#: src/components/compose.jsx:2233
msgid "Image description"
msgstr "Descrição da imagem"

#: src/components/compose.jsx:2234
msgid "Video description"
msgstr "Descrição do vídeo"

#: src/components/compose.jsx:2235
msgid "Audio description"
msgstr "Descrição do áudio"

#: src/components/compose.jsx:2271
#: src/components/compose.jsx:2291
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "O arquivo é muito grande. Enviá-lo pode enfrentar problemas. Reduza o tamanho do arquivo de {0} a {1} ou menor."

#: src/components/compose.jsx:2283
#: src/components/compose.jsx:2303
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "A dimensão é muito grande. Enviá-lo pode enfrentar problemas. Reduza a dimensão de {0}×{1}px a {2}×{3}px."

#: src/components/compose.jsx:2311
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "A taxa de quadros está muito alta. Enviá-lo pode enfrentar problemas."

#: src/components/compose.jsx:2371
#: src/components/compose.jsx:2621
#: src/components/shortcuts-settings.jsx:723
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Remover"

#: src/components/compose.jsx:2388
#: src/compose.jsx:83
msgid "Error"
msgstr "Erro"

#: src/components/compose.jsx:2413
msgid "Edit image description"
msgstr "Editar descrição da imagem"

#: src/components/compose.jsx:2414
msgid "Edit video description"
msgstr "Editar descrição do vídeo"

#: src/components/compose.jsx:2415
msgid "Edit audio description"
msgstr "Editar descrição do áudio"

#: src/components/compose.jsx:2460
#: src/components/compose.jsx:2509
msgid "Generating description. Please wait…"
msgstr "Gerando descrição. Por favor, espere…"

#: src/components/compose.jsx:2480
msgid "Failed to generate description: {0}"
msgstr "Falhou ao gerar descrição: {0}"

#: src/components/compose.jsx:2481
msgid "Failed to generate description"
msgstr "Falhou ao gerar descrição"

#: src/components/compose.jsx:2493
#: src/components/compose.jsx:2499
#: src/components/compose.jsx:2545
msgid "Generate description…"
msgstr "Gerar descrição…"

#: src/components/compose.jsx:2532
msgid "Failed to generate description{0}"
msgstr "Falhou ao gerar descrição{0}"

#: src/components/compose.jsx:2547
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— experimental</0>"

#: src/components/compose.jsx:2566
msgid "Done"
msgstr "Concluído"

#: src/components/compose.jsx:2602
msgid "Choice {0}"
msgstr "Escolha {0}"

#: src/components/compose.jsx:2649
msgid "Multiple choices"
msgstr "Várias escolhas"

#: src/components/compose.jsx:2652
msgid "Duration"
msgstr "Duração"

#: src/components/compose.jsx:2683
msgid "Remove poll"
msgstr "Excluir enquete"

#: src/components/compose.jsx:2897
msgid "Search accounts"
msgstr "Procurar contas"

#: src/components/compose.jsx:2938
#: src/components/shortcuts-settings.jsx:712
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Adicionar"

#: src/components/compose.jsx:2951
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Erro ao carregar contas"

#: src/components/compose.jsx:3094
msgid "Custom emojis"
msgstr "Emojis personalizados"

#: src/components/compose.jsx:3114
msgid "Search emoji"
msgstr "Procurar emoji"

#: src/components/compose.jsx:3145
msgid "Error loading custom emojis"
msgstr "Erro ao carregar emojis personalizados"

#: src/components/compose.jsx:3156
msgid "Recently used"
msgstr "Usado recentemente"

#: src/components/compose.jsx:3157
msgid "Others"
msgstr "Outros"

#: src/components/compose.jsx:3195
msgid "{0} more…"
msgstr "{0} mais…"

#: src/components/compose.jsx:3333
msgid "Search GIFs"
msgstr "Procurar GIFs"

#: src/components/compose.jsx:3348
msgid "Powered by GIPHY"
msgstr "Desenvolvido por GIPHY"

#: src/components/compose.jsx:3356
msgid "Type to search GIFs"
msgstr "Escreva para pesquisar GIFs"

#: src/components/compose.jsx:3454
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:883
msgid "Previous"
msgstr "Anterior"

#: src/components/compose.jsx:3472
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:900
msgid "Next"
msgstr "Seguinte"

#: src/components/compose.jsx:3489
msgid "Error loading GIFs"
msgstr "Erro ao carregar GIFs"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:684
msgid "Unsent drafts"
msgstr "Rascunhos não enviados"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Parece que você tem alguns rascunhos não enviados. Vamos continuar de onde você parou."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Excluir rascunho?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Erro ao excluir rascunho! Tente novamente."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1250
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Excluir…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Erro ao obter estado de resposta!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Excluir rascunhos?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Erro ao excluir rascunhos! Tente novamente."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Excluir tudo…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Nenhum rascunho encontrado."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1911
msgid "Poll"
msgstr "Enquete"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Mídia"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Abrir em nova janela"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:890
msgid "Accept"
msgstr "Aceitar"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Rejeitar"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1173
msgid "Accepted"
msgstr "Aceitado"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Rejeitado"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nada para exibir"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:429
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Contas"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:516
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:820
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1289
msgid "Show more…"
msgstr "Mostrar mais…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:521
#: src/pages/search.jsx:459
msgid "The end."
msgstr "O fim."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1602
msgid "Keyboard shortcuts"
msgstr "Atalhos do teclado"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Ajuda em atalhos do teclado"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1627
msgid "Next post"
msgstr "Publicação seguinte"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1635
msgid "Previous post"
msgstr "Publicação anterior"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Pular carrossel para a publicação seguinte"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Pular carrossel para a publicação anterior"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Carregar novas publicações"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1659
msgid "Open post details"
msgstr "Abrir detalhes da publicação"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> ou <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Expandir aviso de conteúdo ou<0/>alternar tópico expandido/colapsado"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Fechar publicação ou diálogos"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> ou <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Focar coluna no modo multi-coluna"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> a <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Escrever nova publicação"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Escrever nova publicação (nova janela)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Enviar publicação"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> ou <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:176
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Pesquisar"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Responder (nova janela)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Gostei (favorito)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> ou <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:838
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
#: src/components/status.jsx:2326
msgid "Boost"
msgstr "Impulsionar"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:923
#: src/components/status.jsx:2350
#: src/components/status.jsx:2351
msgid "Bookmark"
msgstr "Marcar"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Alternar modo oculto"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Editar lista"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Não foi possível editar lista."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Não foi possível criar lista."

#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Nome"

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Mostrar respostas para membros da lista"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Mostrar respostas para pessoas que sigo"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Não mostrar respostas"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Ocultar publicações nessa lista do Início/Seguindo"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Criar"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Excluir lista?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Não foi possível excluir lista."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Descrição da mídia"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:967
#: src/components/status.jsx:994
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Traduzir"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:981
#: src/components/status.jsx:1008
msgid "Speak"
msgstr "Falar"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Abrir mídia original em nova janela"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Abrir mídia original"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Tentando descrever imagem. Por favor, espere…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Falhou ao descrever imagem"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Descrever imagem…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Ver publicação"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Mídia sensível"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrado: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3401
#: src/components/status.jsx:3497
#: src/components/status.jsx:3575
#: src/components/timeline.jsx:967
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1859
msgid "Filtered"
msgstr "Filtrado"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Publicado. Dê uma conferida."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Resposta publicada. Dê uma conferida."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Publicação atualizada. Dê uma conferida."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Recarregar página agora para atualizar?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nova atualização disponível…"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Acompanhar"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:143
#: src/pages/home.jsx:223
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1020
#: src/pages/trending.jsx:347
msgid "Mentions"
msgstr "Menções"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:149
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:83
#: src/pages/home.jsx:183
#: src/pages/notifications.jsx:106
#: src/pages/notifications.jsx:509
msgid "Notifications"
msgstr "Notificações"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Novo"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Perfil"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:155
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Listas"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Todas as listas"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:192
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Marcadores"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:198
#: src/pages/catchup.jsx:1429
#: src/pages/catchup.jsx:2045
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1024
msgid "Likes"
msgstr "Gostei"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Hashtags seguidas"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtros"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Usuários silenciados"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Usuários silenciados…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Usuários bloqueados"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Usuários bloqueados…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Contas…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:166
#: src/pages/status.jsx:792
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Iniciar sessão"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:169
#: src/pages/trending.jsx:407
msgid "Trending"
msgstr "Tendência"

#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:162
msgid "Local"
msgstr "Local"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:162
msgid "Federated"
msgstr "Federado"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Atalhos / Colunas…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Opções…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Notificação"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Está notificação é da sua outra conta."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Ver todas as notificações"

#: src/components/notification.jsx:68
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reagiu a sua publicação com {emojiObject}"

#: src/components/notification.jsx:75
msgid "{account} published a post."
msgstr "{account} fez uma publicação."

#: src/components/notification.jsx:83
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} impulsionou sua resposta.} other {{account} impulsionou sua publicação.}}} other {{account} impulsionou {postsCount} publicações suas.}}} other {{postType, select, reply {<0><1>{0}</1> pessoa(s)</0> impulsionou sua resposta.} other {<2><3>{1}</3> pessoa(s)</2> impulsionou sua publicação.}}}}"

#: src/components/notification.jsx:126
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} seguiu você.} other {<0><1>{0}</1> pessoa(s)</0> seguiu você.}}"

#: src/components/notification.jsx:140
msgid "{account} requested to follow you."
msgstr "{account} solicitou seguir você."

#: src/components/notification.jsx:149
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} curtiu sua resposta.} other {{account} curtiu sua publicação.}}} other {{account} curtiu {postsCount} publicações suas.}}} other {{postType, select, reply {<0><1>{0}</1>pessoa(s)</0> curtiu sua resposta.} other {<2><3>{1}</3> pessoa(s)</2> curtiram sua publicação.}}}}"

#: src/components/notification.jsx:191
msgid "A poll you have voted in or created has ended."
msgstr "A enquete que você votou/criou já acabou."

#: src/components/notification.jsx:192
msgid "A poll you have created has ended."
msgstr "A enquete que você criou já acabou."

#: src/components/notification.jsx:193
msgid "A poll you have voted in has ended."
msgstr "A enquete que você votou já acabou."

#: src/components/notification.jsx:194
msgid "A post you interacted with has been edited."
msgstr "Uma publicação que você interagiu foi editada."

#: src/components/notification.jsx:202
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} impulsionou e curtiu sua resposta.} other {{account} impulsionou e curtiu dua publicação.}}} other {{account} impulsionou e curtiu {postsCount} publicações suas.}}} other {{postType, select, reply {<0><1>{0}</1> pessoa(s)</0> impulsionou e curtiu sua resposta.} other {<2><3>{1}</3> pessoa(s)</2> impulsionou e curtiu sua publicação.}}}}"

#: src/components/notification.jsx:244
msgid "{account} signed up."
msgstr "{account} registrada."

#: src/components/notification.jsx:246
msgid "{account} reported {targetAccount}"
msgstr "{account} denunciou {targetAccount}"

#: src/components/notification.jsx:251
msgid "Lost connections with <0>{name}</0>."
msgstr "Perdeu conexões com <0>{name}</0>."

#: src/components/notification.jsx:257
msgid "Moderation warning"
msgstr "Aviso da moderação"

#: src/components/notification.jsx:267
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Um administrador de <0>{from}</0> suspendeu <1>{targetName}</1></0>, O que significa que você não receberá atualizações ou interações deles."

#: src/components/notification.jsx:273
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Um administrador de <0>{from}</0> bloqueou <1>{targetName}</1>. Seguidores afetados: {followersCount}, Seguindo: {followingCount}."

#: src/components/notification.jsx:279
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Você bloqueou<0>{targetName}</0>.\n"
"Seguidores removidos: {followersCount}, Seguindo: {followingCount}."

#: src/components/notification.jsx:287
msgid "Your account has received a moderation warning."
msgstr "Sua conta recebeu um aviso da moderação."

#: src/components/notification.jsx:288
msgid "Your account has been disabled."
msgstr "Sua conta foi desativada."

#: src/components/notification.jsx:289
msgid "Some of your posts have been marked as sensitive."
msgstr "Algumas das suas publicações foram marcadas como sensíveis."

#: src/components/notification.jsx:290
msgid "Some of your posts have been deleted."
msgstr "Algumas publicações suas foram excluídas."

#: src/components/notification.jsx:291
msgid "Your posts will be marked as sensitive from now on."
msgstr "Suas publicações foram marcadas como sensível de agora em diante."

#: src/components/notification.jsx:292
msgid "Your account has been limited."
msgstr "Sua conta foi limitada."

#: src/components/notification.jsx:293
msgid "Your account has been suspended."
msgstr "Sua conta foi suspensa."

#: src/components/notification.jsx:364
msgid "[Unknown notification type: {type}]"
msgstr "[Tipo de notificação desconhecida: {type}]"

#: src/components/notification.jsx:425
#: src/components/status.jsx:937
#: src/components/status.jsx:947
msgid "Boosted/Liked by…"
msgstr "Impulsionado/Curtido por…"

#: src/components/notification.jsx:426
msgid "Liked by…"
msgstr "Curtido por…"

#: src/components/notification.jsx:427
msgid "Boosted by…"
msgstr "Impulsionado por…"

#: src/components/notification.jsx:428
msgid "Followed by…"
msgstr "Seguido por…"

#: src/components/notification.jsx:484
#: src/components/notification.jsx:500
msgid "Learn more <0/>"
msgstr "Saiba mais <0/>"

#: src/components/notification.jsx:680
#: src/components/status.jsx:189
msgid "Read more →"
msgstr "Leia mais →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Votado"

#: src/components/poll.jsx:135
#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Hide results"
msgstr "Ocultar resultado"

#: src/components/poll.jsx:184
msgid "Vote"
msgstr "Votar"

#: src/components/poll.jsx:204
#: src/components/poll.jsx:206
#: src/pages/status.jsx:1158
#: src/pages/status.jsx:1181
msgid "Refresh"
msgstr "Atualizar"

#: src/components/poll.jsx:218
#: src/components/poll.jsx:222
msgid "Show results"
msgstr "Exibir resultado"

#: src/components/poll.jsx:227
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> voto} other {<1>{1}</1> votos}}"

#: src/components/poll.jsx:244
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votante} other {<1>{1}</1> votantes}}"

#: src/components/poll.jsx:264
msgid "Ended <0/>"
msgstr "Acabou <0/>"

#: src/components/poll.jsx:268
msgid "Ended"
msgstr "Acabou"

#: src/components/poll.jsx:271
msgid "Ending <0/>"
msgstr "Acabando <0/>"

#: src/components/poll.jsx:275
msgid "Ending"
msgstr "Acabando"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:55
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:60
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:65
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Links falsos, interações falsas, ou respostas repetitivas"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Illegal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viola a lei do seu ou do país do servidor"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Regra de violação do servidor"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Quebra regras específicas do servidor"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Violação"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Outro"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "O problema não se encaixa em outras categorias"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Denunciar publicação"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Denunciar @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Revisão pendente"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Publicação denunciada"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Perfil denunciado"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Não foi possível denunciar publicação"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Não foi possível denunciar perfil"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Qual é o problema com a publicação?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Qual é o problema com o perfil?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informações adicionais"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Encaminhar à <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Enviar denuncia"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silenciou {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Não foi possível silenciar {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Enviar denuncia <0>+ Silenciar perfil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Bloqueou {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Não foi possível bloquear {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Enviar denuncia <0>+ Bloquear perfil</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ contas, hashtags e publicações</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Publicações com <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Publicações marcadas com <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Procurar <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Contas com <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Inicio / Seguindo"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Público (Local / Federado)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Conta"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID de lista"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Apenas local"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:170
msgid "Instance"
msgstr "Instância"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Opcional, ex.: mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Procurar termo"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Opcional, menos para o modo multi-coluna"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "ex.: PixelArt (Máx. 5, separado por espaço)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Apenas mídia"

#: src/components/shortcuts-settings.jsx:232
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Atalhos"

#: src/components/shortcuts-settings.jsx:240
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:246
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Especifique uma lista de atalhos que aparecerá como:"

#: src/components/shortcuts-settings.jsx:252
msgid "Floating button"
msgstr "Botão flutuante"

#: src/components/shortcuts-settings.jsx:257
msgid "Tab/Menu bar"
msgstr "Aba/Barra do menu"

#: src/components/shortcuts-settings.jsx:262
msgid "Multi-column"
msgstr "Multi-coluna"

#: src/components/shortcuts-settings.jsx:329
msgid "Not available in current view mode"
msgstr "Indisponível no modo atual de visualização"

#: src/components/shortcuts-settings.jsx:348
msgid "Move up"
msgstr "Mover para cima"

#: src/components/shortcuts-settings.jsx:364
msgid "Move down"
msgstr "Mover para baixo"

#: src/components/shortcuts-settings.jsx:376
#: src/components/status.jsx:1215
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Editar"

#: src/components/shortcuts-settings.jsx:397
msgid "Add more than one shortcut/column to make this work."
msgstr "Adicione mais de um(a) atalho/coluna para fazer funcionar."

#: src/components/shortcuts-settings.jsx:408
msgid "No columns yet. Tap on the Add column button."
msgstr "Nenhuma coluna ainda. Clique no botão de adicionar coluna."

#: src/components/shortcuts-settings.jsx:409
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Nenhum atalho ainda. Clique no botão de adicionar atalho."

#: src/components/shortcuts-settings.jsx:412
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Sem certeza do que adicionar?<0/>Tente adicionando <1>Notificações do Início / Seguindo </1> primeiramente."

#: src/components/shortcuts-settings.jsx:440
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Máximo {SHORTCUTS_LIMIT} colunas"

#: src/components/shortcuts-settings.jsx:441
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Máximo {SHORTCUTS_LIMIT} atalhos"

#: src/components/shortcuts-settings.jsx:455
msgid "Import/export"
msgstr "Importar/Exportar"

#: src/components/shortcuts-settings.jsx:465
msgid "Add column…"
msgstr "Adicionar coluna…"

#: src/components/shortcuts-settings.jsx:466
msgid "Add shortcut…"
msgstr "Adicionar atalho…"

#: src/components/shortcuts-settings.jsx:513
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "A lista específica é opcional. Para o modo multi-coluna, a lista é necessária, ou a coluna não será exibida."

#: src/components/shortcuts-settings.jsx:514
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Para o modo multi-coluna, procurar o termo é necessário, ou a coluna não será exibida."

#: src/components/shortcuts-settings.jsx:515
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Várias hashtags são suportadas. Separado por espaço."

#: src/components/shortcuts-settings.jsx:584
msgid "Edit shortcut"
msgstr "Editar atalho"

#: src/components/shortcuts-settings.jsx:584
msgid "Add shortcut"
msgstr "Adicionar atalho"

#: src/components/shortcuts-settings.jsx:620
msgid "Timeline"
msgstr "Linha do tempo"

#: src/components/shortcuts-settings.jsx:646
msgid "List"
msgstr "Lista"

#: src/components/shortcuts-settings.jsx:785
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importar/Exportar <0>atalhos</0>"

#: src/components/shortcuts-settings.jsx:795
msgid "Import"
msgstr "Importar"

#: src/components/shortcuts-settings.jsx:803
msgid "Paste shortcuts here"
msgstr "Cole atalhos aqui"

#: src/components/shortcuts-settings.jsx:819
msgid "Downloading saved shortcuts from instance server…"
msgstr "Baixando salvou atalhos do servidor de instância…"

#: src/components/shortcuts-settings.jsx:848
msgid "Unable to download shortcuts"
msgstr "Não foi possível baixar atalhos"

#: src/components/shortcuts-settings.jsx:851
msgid "Download shortcuts from instance server"
msgstr "Baixar atalhos do servidor de instância"

#: src/components/shortcuts-settings.jsx:909
msgid "* Exists in current shortcuts"
msgstr "* Existe nos atuais atalhos"

#: src/components/shortcuts-settings.jsx:914
msgid "List may not work if it's from a different account."
msgstr "A lista pode não funcionar se for de uma conta diferente."

#: src/components/shortcuts-settings.jsx:924
msgid "Invalid settings format"
msgstr "Formato de opções inválido"

#: src/components/shortcuts-settings.jsx:932
msgid "Append to current shortcuts?"
msgstr "Anexar aos atalhos atuais?"

#: src/components/shortcuts-settings.jsx:935
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Apenas atalhos que não existem no atalho atual serão anexados."

#: src/components/shortcuts-settings.jsx:957
msgid "No new shortcuts to import"
msgstr "Nenhum atalho novo para importar"

#: src/components/shortcuts-settings.jsx:972
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Atalhos importados. Máximo excedido {SHORTCUTS_LIMIT}, então o resto não será importado."

#: src/components/shortcuts-settings.jsx:973
#: src/components/shortcuts-settings.jsx:997
msgid "Shortcuts imported"
msgstr "Atalhos importados"

#: src/components/shortcuts-settings.jsx:983
msgid "Import & append…"
msgstr "Importar e anexar…"

#: src/components/shortcuts-settings.jsx:991
msgid "Override current shortcuts?"
msgstr "Substituir atalhos atuais?"

#: src/components/shortcuts-settings.jsx:992
msgid "Import shortcuts?"
msgstr "Importar atalhos?"

#: src/components/shortcuts-settings.jsx:1006
msgid "or override…"
msgstr "ou substituir…"

#: src/components/shortcuts-settings.jsx:1006
msgid "Import…"
msgstr "Importar…"

#: src/components/shortcuts-settings.jsx:1015
msgid "Export"
msgstr "Exportar"

#: src/components/shortcuts-settings.jsx:1030
msgid "Shortcuts copied"
msgstr "Atalhos copiados"

#: src/components/shortcuts-settings.jsx:1033
msgid "Unable to copy shortcuts"
msgstr "Não foi possível copiar atalhos"

#: src/components/shortcuts-settings.jsx:1047
msgid "Shortcut settings copied"
msgstr "Opções de atalhos copiados"

#: src/components/shortcuts-settings.jsx:1050
msgid "Unable to copy shortcut settings"
msgstr "Não foi possível copiar as opções de atalho"

#: src/components/shortcuts-settings.jsx:1080
msgid "Share"
msgstr "Compartilhar"

#: src/components/shortcuts-settings.jsx:1119
msgid "Saving shortcuts to instance server…"
msgstr "Salvando atalhos no servidor de instância…"

#: src/components/shortcuts-settings.jsx:1126
msgid "Shortcuts saved"
msgstr "Atalhos salvos"

#: src/components/shortcuts-settings.jsx:1131
msgid "Unable to save shortcuts"
msgstr "Não foi possível salvar atalhos"

#: src/components/shortcuts-settings.jsx:1134
msgid "Sync to instance server"
msgstr "Sincronizar para o servidor de instância"

#: src/components/shortcuts-settings.jsx:1142
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# carácter} other {# carácteres}}"

#: src/components/shortcuts-settings.jsx:1154
msgid "Raw Shortcuts JSON"
msgstr "Atalhos brutos JSON"

#: src/components/shortcuts-settings.jsx:1167
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importar/exportar opções de/para servidor de instância (Muito experimental)"

#: src/components/status.jsx:463
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>impulsionado</1>"

#: src/components/status.jsx:562
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Desculpa, a atual instância registrada não pode interagir com esta publicação de outra instância."

#: src/components/status.jsx:715
msgid "Unliked @{0}'s post"
msgstr "Não gostou da publicação de @{0}"

#: src/components/status.jsx:716
msgid "Liked @{0}'s post"
msgstr "Curtiu a publicação de @{0}"

#: src/components/status.jsx:755
msgid "Unbookmarked @{0}'s post"
msgstr "Desmarcou a publicação de @{0}"

#: src/components/status.jsx:756
msgid "Bookmarked @{0}'s post"
msgstr "Marcou a publicação de @{0}"

#: src/components/status.jsx:838
#: src/components/status.jsx:900
#: src/components/status.jsx:2293
#: src/components/status.jsx:2325
msgid "Unboost"
msgstr "Remover impulso"

#: src/components/status.jsx:854
#: src/components/status.jsx:2308
msgid "Quote"
msgstr "Citar"

#: src/components/status.jsx:862
#: src/components/status.jsx:2317
msgid "Some media have no descriptions."
msgstr "Algumas mídias não têm descrições."

#: src/components/status.jsx:869
msgid "Old post (<0>{0}</0>)"
msgstr "Publicação antiga (<0>{0}</0>)"

#: src/components/status.jsx:888
#: src/components/status.jsx:1340
msgid "Unboosted @{0}'s post"
msgstr "Removeu impulso da publicação de @{0}"

#: src/components/status.jsx:889
#: src/components/status.jsx:1341
msgid "Boosted @{0}'s post"
msgstr "Impulsionou a publicação de @{0}"

#: src/components/status.jsx:901
msgid "Boost…"
msgstr "Impulsionar…"

#: src/components/status.jsx:913
#: src/components/status.jsx:1625
#: src/components/status.jsx:2338
msgid "Unlike"
msgstr "Não gostei"

#: src/components/status.jsx:914
#: src/components/status.jsx:1625
#: src/components/status.jsx:1626
#: src/components/status.jsx:2338
#: src/components/status.jsx:2339
msgid "Like"
msgstr "Gostei"

#: src/components/status.jsx:923
#: src/components/status.jsx:2350
msgid "Unbookmark"
msgstr "Desmarcar"

#: src/components/status.jsx:1031
msgid "View post by <0>@{0}</0>"
msgstr "Ver publicação de <0>@{0}</0>"

#: src/components/status.jsx:1052
msgid "Show Edit History"
msgstr "Exibir histórico de edições"

#: src/components/status.jsx:1055
msgid "Edited: {editedDateText}"
msgstr "Editado: {editedDateText}"

#: src/components/status.jsx:1122
#: src/components/status.jsx:3078
msgid "Embed post"
msgstr "Incorporar publicação"

#: src/components/status.jsx:1136
msgid "Conversation unmuted"
msgstr "Conversa dessilenciada"

#: src/components/status.jsx:1136
msgid "Conversation muted"
msgstr "Conversa silenciada"

#: src/components/status.jsx:1142
msgid "Unable to unmute conversation"
msgstr "Não foi possível dessilenciar conversa"

#: src/components/status.jsx:1143
msgid "Unable to mute conversation"
msgstr "Não foi possível silenciar a conversa"

#: src/components/status.jsx:1152
msgid "Unmute conversation"
msgstr "Dessilenciar conversa"

#: src/components/status.jsx:1159
msgid "Mute conversation"
msgstr "Silenciar conversa"

#: src/components/status.jsx:1175
msgid "Post unpinned from profile"
msgstr "Publicação desafixada do perfil"

#: src/components/status.jsx:1176
msgid "Post pinned to profile"
msgstr "Publicação fixada no perfil"

#: src/components/status.jsx:1181
msgid "Unable to unpin post"
msgstr "Não foi possível desafixar publicação"

#: src/components/status.jsx:1181
msgid "Unable to pin post"
msgstr "Não foi possível fixar publicação"

#: src/components/status.jsx:1190
msgid "Unpin from profile"
msgstr "Desafixar do perfil"

#: src/components/status.jsx:1197
msgid "Pin to profile"
msgstr "Fixar ao perfil"

#: src/components/status.jsx:1226
msgid "Delete this post?"
msgstr "Excluir publicação?"

#: src/components/status.jsx:1239
msgid "Post deleted"
msgstr "Publicação excluída"

#: src/components/status.jsx:1242
msgid "Unable to delete post"
msgstr "Não foi possível excluir publicação"

#: src/components/status.jsx:1270
msgid "Report post…"
msgstr "Denunciar publicação…"

#: src/components/status.jsx:1626
#: src/components/status.jsx:1662
#: src/components/status.jsx:2339
msgid "Liked"
msgstr "Curtido"

#: src/components/status.jsx:1659
#: src/components/status.jsx:2326
msgid "Boosted"
msgstr "Impulsionado"

#: src/components/status.jsx:1669
#: src/components/status.jsx:2351
msgid "Bookmarked"
msgstr "Marcado"

#: src/components/status.jsx:1673
msgid "Pinned"
msgstr "Fixado"

#: src/components/status.jsx:1718
#: src/components/status.jsx:2170
msgid "Deleted"
msgstr "Excluído"

#: src/components/status.jsx:1759
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# resposta} other {# respostas}}"

#: src/components/status.jsx:1848
msgid "Thread{0}"
msgstr "Tópico{0}"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
#: src/components/status.jsx:2071
msgid "Show less"
msgstr "Mostrar menos"

#: src/components/status.jsx:1924
#: src/components/status.jsx:1986
msgid "Show content"
msgstr "Mostrar conteúdo"

#: src/components/status.jsx:2071
msgid "Show media"
msgstr "Mostrar mídia"

#: src/components/status.jsx:2191
msgid "Edited"
msgstr "Editado"

#: src/components/status.jsx:2268
msgid "Comments"
msgstr "Comentários"

#: src/components/status.jsx:2839
msgid "Edit History"
msgstr "Histórico de edições"

#: src/components/status.jsx:2843
msgid "Failed to load history"
msgstr "Falhou ao carregar histórico"

#: src/components/status.jsx:2848
msgid "Loading…"
msgstr "Carregando…"

#: src/components/status.jsx:3083
msgid "HTML Code"
msgstr "Código HTML"

#: src/components/status.jsx:3100
msgid "HTML code copied"
msgstr "Código HTML copiado"

#: src/components/status.jsx:3103
msgid "Unable to copy HTML code"
msgstr "Não foi possível copiar código HTML"

#: src/components/status.jsx:3115
msgid "Media attachments:"
msgstr "Anexos de mídia:"

#: src/components/status.jsx:3137
msgid "Account Emojis:"
msgstr "Emojis da conta:"

#: src/components/status.jsx:3168
#: src/components/status.jsx:3213
msgid "static URL"
msgstr "URL estático"

#: src/components/status.jsx:3182
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/status.jsx:3227
msgid "Notes:"
msgstr "Notas:"

#: src/components/status.jsx:3231
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Isso é estático, instável e sem script. Você pode precisar para aplicar seus próprios estilos e editar caso necessário."

#: src/components/status.jsx:3237
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Enquetes não são interativas, ela se torna uma lista com contagem de votos."

#: src/components/status.jsx:3242
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Anexos de mídia pode ser imagens, vídeos, áudios ou qualquer arquivo."

#: src/components/status.jsx:3248
msgid "Post could be edited or deleted later."
msgstr "Publicações podem ser editadas ou excluídas depois."

#: src/components/status.jsx:3254
msgid "Preview"
msgstr "Prévia"

#: src/components/status.jsx:3263
msgid "Note: This preview is lightly styled."
msgstr "Nota: Essa prévia é levemente estilizada."

#: src/components/status.jsx:3505
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> impulsionado"

#: src/components/timeline.jsx:450
#: src/pages/settings.jsx:1048
msgid "New posts"
msgstr "Novas publicações"

#: src/components/timeline.jsx:551
#: src/pages/home.jsx:212
#: src/pages/notifications.jsx:796
#: src/pages/status.jsx:945
#: src/pages/status.jsx:1318
msgid "Try again"
msgstr "Tente novamente"

#: src/components/timeline.jsx:940
#: src/components/timeline.jsx:947
#: src/pages/catchup.jsx:1876
msgid "Thread"
msgstr "Tópico"

#: src/components/timeline.jsx:962
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrado</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Traduzido automaticamente de {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Traduzindo…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Tradução de {sourceLangText} (detectado automaticamente)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Tradução de {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Falhou ao traduzir"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Editando mensagem original"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Respondendo à @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Você deve fechar esta página agora."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Fechar janela"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Requer registro."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:247
msgid "Go home"
msgstr "Voltar ao início"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Publicações da conta"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ respostas)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- impulsos)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (mídia)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Limpar filtro"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Limpar"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Exibindo publicação com respostas"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Respostas"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Exibindo publicações sem impulsos"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- impulsos"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Exibindo publicações com mídia"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Exibindo publicações marcadas com #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Exibindo publicações em {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Não há nada para ver aqui."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:415
msgid "Unable to load posts"
msgstr "Não foi possível carregar publicações"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Não foi possível obter informações da conta"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Alterar para instância de conta {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Alterar para a minha instância (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Mês"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Atual"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Padrão"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Alterar para esta conta"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Alterar para nova janela/aba"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Ver perfil…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Definir como padrão"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Encerrar sessão <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Encerrar sessão…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Adicionar conta existente"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Nota: contas <0>padrões</0> sempre serão as primeiras usadas para carregar. Contas alteradas permaneceram durante a sessão."

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Não foi possível carregar marcadores."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "última 1 hora"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "últimas 2 horas"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "últimas 3 horas"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "últimas 4 horas"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "últimas 5 horas"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "últimas 6 horas"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "últimas 7 horas"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "últimas 8 horas"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "últimas 9 horas"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "últimas 10 horas"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "últimas 11 horas"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "últimas 12 horas"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "além de 12 horas"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Tags seguidas"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Grupos"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Exibindo {selectedFilterCategory, select, all {todas as publicações} original {publicações originais} replies {respostas} boosts {impulsos} followedTags {tags seguidas} groups {grupos} filtered {publicações filtradas}}{sortBy, select, createdAt {{sortOrder, select, asc {mais antigo} desc {mais recente}}} reblogsCount {{sortOrder, select, asc {menos impulsos} desc {mais impulsos}}} favouritesCount {{sortOrder, select, asc {menos curtidas} desc {mais curtidas}}} repliesCount {{sortOrder, select, asc {menos respostas} desc {mais respostas}}} density {{sortOrder, select, asc {menos denso} desc {mais denso}}}} primeiro{groupBy, select, account {, agrupado por autores} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Acompanhar <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1568
msgid "Help"
msgstr "Ajuda"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "O que é isso?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Acompanhar é uma linha de tempo separada de seus seguidores, oferecendo uma visualização de alto-nível em um relance, com uma simples interface inspirada em e-mail para ordenar e filtrar sem esforço através das publicações."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Prévia da interface de acompanhamento"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Vamos acompanhar"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Vamos acompanhar as publicações de seus seguidores."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Mostre-me todas as publicações de…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "até o máximo"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Acompanhar"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Sobreposições com o seu último acompanhamento"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Até o último acompanhamento ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Nota: Suas instâncias talvez mostrem um máximo de 800 publicações na linha de tempo do início, independente do intervalo de tempo. Pode ser menos ou mais."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Anteriormente…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# publicação} other {# publicações}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Excluir acompanhamento?"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Nota: Somente armazenará um máximo de 3. O resto será automaticamente excluído."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Obtendo publicações…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Isso deve levar um tempo."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Redefinir filtros"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1574
msgid "Top links"
msgstr "Links populares"

#: src/pages/catchup.jsx:1260
msgid "Shared by {0}"
msgstr "Compartilhado por {0}"

#: src/pages/catchup.jsx:1299
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Tudo"

#: src/pages/catchup.jsx:1384
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autor} other {# autores}}"

#: src/pages/catchup.jsx:1396
msgid "Sort"
msgstr "Ordenar"

#: src/pages/catchup.jsx:1427
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1431
msgid "Density"
msgstr "Densidade"

#: src/pages/catchup.jsx:1469
msgid "Authors"
msgstr "Autores"

#: src/pages/catchup.jsx:1470
msgid "None"
msgstr "Nenhum"

#: src/pages/catchup.jsx:1486
msgid "Show all authors"
msgstr "Exibir autores"

#: src/pages/catchup.jsx:1537
msgid "You don't have to read everything."
msgstr "Você não precisa ler tudo."

#: src/pages/catchup.jsx:1538
msgid "That's all."
msgstr "Isso é tudo."

#: src/pages/catchup.jsx:1546
msgid "Back to top"
msgstr "Voltar ao topo"

#: src/pages/catchup.jsx:1577
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Links compartilhados por seguidores, ordenados pela contagem de compartilhamentos, impulsos e curtidas."

#: src/pages/catchup.jsx:1583
msgid "Sort: Density"
msgstr "Ordenar: Densidade"

#: src/pages/catchup.jsx:1586
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Publicações são ordenadas por informações de densidade ou profundidade. As curtas são mais \"leves\" enquanto as maiores são mais \"pesadas\". Publicações com fotos são mais \"pesadas\" do que elas sem fotos."

#: src/pages/catchup.jsx:1593
msgid "Group: Authors"
msgstr "Grupo: Autores"

#: src/pages/catchup.jsx:1596
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Publicações são agrupadas por autores, ordenado por quantidade de publicações por autor."

#: src/pages/catchup.jsx:1643
msgid "Next author"
msgstr "Próximo autor"

#: src/pages/catchup.jsx:1651
msgid "Previous author"
msgstr "Autor anterior"

#: src/pages/catchup.jsx:1667
msgid "Scroll to top"
msgstr "Rolar até o topo"

#: src/pages/catchup.jsx:1858
msgid "Filtered: {0}"
msgstr "Filtrado: {0}"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Não foi possível carregar curtidas."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Início e listas"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Linhas de tempo públicas"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Conversas"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Perfis"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Nunca"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Filtro novo"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtro} other {# filtros}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Não foi possível carregar filtros."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Sem filtro ainda."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Adicionar filtro"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Editar filtro"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Não foi possível editar filtro"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Não foi possível criar filtro"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Título"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Palavra toda"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Sem palavras-chave. Adicione uma."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Adicionar palavra-chave"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# palavra-chave} other {# palavras-chave}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtrar de…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Ainda não implementado"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Estado: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Alterar expiração"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Expiração"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Publicação filtrada será…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimizada"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "oculta"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Excluir filtro?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Não foi possível excluir filtro."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Expirado"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Expirando <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Nunca expira"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# hashtag} other {# hashtags}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Não foi possível carregar hashtags seguidas."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Nenhuma hashtag seguida ainda."

#: src/pages/following.jsx:133
msgid "Nothing to see here."
msgstr "Nada para ver aqui."

#: src/pages/following.jsx:134
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Não foi possível carregar publicações."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (apenas mídia) em {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} em {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (apenas mídia)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Ninguém publicou nada com esta tag ainda."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Não foi possível carregar publicações com esta tag"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Parou de seguir #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Seguido #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Seguindo…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Não destacado no perfil"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Não foi possível parar de destacar no perfil"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Destacado no perfil"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Destacar no perfil"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {Máx. # tags}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Adicionar hashtag"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Excluir hashtag"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Máx. # atalho alcançado. Não foi possível adicionar atalho.} other {Máx. # atalhos alcançados. Não foi possível adicionar atalho.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Este atalho já existe"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Atalho da hashtag adicionada"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Adicionar aos atalhos"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:444
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Insira uma nova instância ex. \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:447
msgid "Invalid instance"
msgstr "Instância inválida"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:459
msgid "Go to another instance…"
msgstr "Vá para outra instância…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:470
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Vá para minha instância (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:208
msgid "Unable to fetch notifications."
msgstr "Não foi possível obter notificações."

#: src/pages/home.jsx:228
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nova(s)</0> <1>Solicitação(ões) de seguimento</1>"

#: src/pages/home.jsx:234
msgid "See all"
msgstr "Ver tudo"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Resolvendo…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Não foi possível resolver URL"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Nada ainda."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Gerenciar membros"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Excluir <0>@{0}</0> da lista?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Excluir…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# lista} other {# listas}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Nenhuma lista ainda."

#: src/pages/login.jsx:86
#: src/pages/login.jsx:99
msgid "Failed to register application"
msgstr "Falhou ao registrar aplicativo"

#: src/pages/login.jsx:209
msgid "e.g. “mastodon.social”"
msgstr "ex. “mastodon.social”"

#: src/pages/login.jsx:220
msgid "Failed to log in. Please try again or try another instance."
msgstr "Falhou ao iniciar sessão. Tente novamente ou tente outra instância."

#: src/pages/login.jsx:232
msgid "Continue with {selectedInstanceText}"
msgstr "Continuar com {selectedInstanceText}"

#: src/pages/login.jsx:233
msgid "Continue"
msgstr "Continuar"

#: src/pages/login.jsx:241
msgid "Don't have an account? Create one!"
msgstr "Não tem uma conta? Crie uma!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Menções privadas"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privado"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Ninguém mencionou você :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Não foi possível carregar menções."

#: src/pages/notifications.jsx:97
msgid "You don't follow"
msgstr "Você não segue"

#: src/pages/notifications.jsx:98
msgid "Who don't follow you"
msgstr "Quem não segue você"

#: src/pages/notifications.jsx:99
msgid "With a new account"
msgstr "Com uma conta nova"

#: src/pages/notifications.jsx:100
msgid "Who unsolicitedly private mention you"
msgstr "Quem mencionou você privadamente sem solicitar"

#: src/pages/notifications.jsx:101
msgid "Who are limited by server moderators"
msgstr "Quem está limitado por moderadores do servidor"

#: src/pages/notifications.jsx:523
#: src/pages/notifications.jsx:844
msgid "Notifications settings"
msgstr "Opções de notificação"

#: src/pages/notifications.jsx:541
msgid "New notifications"
msgstr "Novas notificações"

#: src/pages/notifications.jsx:552
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Anúncio} other {Anúncios}}"

#: src/pages/notifications.jsx:599
#: src/pages/settings.jsx:1036
msgid "Follow requests"
msgstr "Solicitações de seguimento"

#: src/pages/notifications.jsx:604
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# solicitação de seguimento} other {# solicitações de seguimento}}"

#: src/pages/notifications.jsx:659
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Notificações filtradas de # pessoa} other {Notificações filtradas de # pessoas}}"

#: src/pages/notifications.jsx:725
msgid "Only mentions"
msgstr "Apenas menções"

#: src/pages/notifications.jsx:729
msgid "Today"
msgstr "Hoje"

#: src/pages/notifications.jsx:733
msgid "You're all caught up."
msgstr "Está tudo em dia."

#: src/pages/notifications.jsx:756
msgid "Yesterday"
msgstr "Ontem"

#: src/pages/notifications.jsx:792
msgid "Unable to load notifications"
msgstr "Não foi possível carregar notificações"

#: src/pages/notifications.jsx:871
msgid "Notifications settings updated"
msgstr "Opções de notificação atualizada"

#: src/pages/notifications.jsx:879
msgid "Filter out notifications from people:"
msgstr "Filtrar notificações de pessoas:"

#: src/pages/notifications.jsx:893
msgid "Filter"
msgstr "Filtro"

#: src/pages/notifications.jsx:896
msgid "Ignore"
msgstr "Ignorar"

#: src/pages/notifications.jsx:969
msgid "Updated <0>{0}</0>"
msgstr "Atualizado <0>{0}</0>"

#: src/pages/notifications.jsx:1037
msgid "View notifications from <0>@{0}</0>"
msgstr "Ver notificações de <0>@{0}</0>"

#: src/pages/notifications.jsx:1058
msgid "Notifications from <0>@{0}</0>"
msgstr "Notificações de <0>@{0}</0>"

#: src/pages/notifications.jsx:1125
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Notificações de @{0} não serão mais filtradas."

#: src/pages/notifications.jsx:1130
msgid "Unable to accept notification request"
msgstr "Não foi possível aceitar solicitação de notificação"

#: src/pages/notifications.jsx:1135
msgid "Allow"
msgstr "Permitir"

#: src/pages/notifications.jsx:1155
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Notificações de @{0} não aparecerá em notificações filtradas."

#: src/pages/notifications.jsx:1160
msgid "Unable to dismiss notification request"
msgstr "Não foi possível descartar solicitação de notificação"

#: src/pages/notifications.jsx:1165
msgid "Dismiss"
msgstr "Descartar"

#: src/pages/notifications.jsx:1180
msgid "Dismissed"
msgstr "Descartado"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Linha de tempo local ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Linha de tempo federada ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Linha de tempo local"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Linha de tempo federada"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Ninguém publicou nada ainda."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Alterar para federado"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Alterar para local"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Procurar: {q} (Publicações)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Pesquisar: {q} (Contas)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Pesquisar: {q} (Hashtags)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Pesquisar: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Hashtags"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Ver mais"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Ver mais contas"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Nenhuma conta encontrada."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Ver mais hashtags"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "Nenhuma hashtag encontrada."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Ver mais publicações"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "Nenhuma publicação encontrada."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Insira o termo de sua pesquisa ou copie um URL acima para iniciar."

#: src/pages/settings.jsx:74
msgid "Settings"
msgstr "Opções"

#: src/pages/settings.jsx:83
msgid "Appearance"
msgstr "Aparência"

#: src/pages/settings.jsx:159
msgid "Light"
msgstr "Claro"

#: src/pages/settings.jsx:170
msgid "Dark"
msgstr "Escuro"

#: src/pages/settings.jsx:183
msgid "Auto"
msgstr "Automático"

#: src/pages/settings.jsx:193
msgid "Text size"
msgstr "Tamanho do texto"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:198
#: src/pages/settings.jsx:223
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:237
msgid "Display language"
msgstr "Idioma de exibição"

#: src/pages/settings.jsx:246
msgid "Volunteer translations"
msgstr "Traduções voluntárias"

#: src/pages/settings.jsx:257
msgid "Posting"
msgstr "Publicando"

#: src/pages/settings.jsx:264
msgid "Default visibility"
msgstr "Visibilidade padrão"

#: src/pages/settings.jsx:265
#: src/pages/settings.jsx:311
msgid "Synced"
msgstr "Sincronizado"

#: src/pages/settings.jsx:290
msgid "Failed to update posting privacy"
msgstr "Falhou ao atualizar a privacidade de publicação"

#: src/pages/settings.jsx:313
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sincronizado com as opções do servidor de instância. <0>Vá para sua instância ({instance}) para mais opções.</0>"

#: src/pages/settings.jsx:328
msgid "Experiments"
msgstr "Experimentos"

#: src/pages/settings.jsx:341
msgid "Auto refresh timeline posts"
msgstr "Atualizar automaticamente publicações da linha do tempo"

#: src/pages/settings.jsx:353
msgid "Boosts carousel"
msgstr "Carrossel de impulsos"

#: src/pages/settings.jsx:369
msgid "Post translation"
msgstr "Tradução da publicação"

#: src/pages/settings.jsx:380
msgid "Translate to"
msgstr "Traduzir para"

#: src/pages/settings.jsx:391
msgid "System language ({systemTargetLanguageText})"
msgstr "Idioma do sistema ({systemTargetLanguageText})"

#: src/pages/settings.jsx:417
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {Ocultar o botão de \"Traduzir\" por:} other {Ocultar o botão de \"Traduzir\" por (#):}}"

#: src/pages/settings.jsx:471
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Nota: Este recurso usa serviços externos de tradução, desenvolvido por <0>Lingva API</0> e <1>Lingva Translate</1>."

#: src/pages/settings.jsx:505
msgid "Auto inline translation"
msgstr "Tradução automática"

#: src/pages/settings.jsx:509
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Exibe automaticamente tradução para publicações na linha de tempo. Só funciona para publicações <0>curtas</0> sem aviso de conteúdo, mídia ou enquete."

#: src/pages/settings.jsx:529
msgid "GIF Picker for composer"
msgstr "Selecionador de GIF para escrita"

#: src/pages/settings.jsx:533
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Nota: Este recurso usa serviços externos de pesquisa de GIF, desenvolvido por <0>GIPHY</0>. Avaliado bem (adequado para visualização de todas as idades), rastreando parâmetros são despojados, informação de referência é omitida de solicitações, porém consultas de busca e informação de endereço IP ainda poderá alcançar os servidores deles."

#: src/pages/settings.jsx:562
msgid "Image description generator"
msgstr "Gerador de descrição de imagem"

#: src/pages/settings.jsx:567
msgid "Only for new images while composing new posts."
msgstr "Apenas para novas imagens enquanto escreve novas publicações."

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Nota: Este recurso usa serviços externos IA, desenvolvido por <0>img-alt-api</0>. Então ele pode não funcionar bem. Apenas para imagens e em inglês."

#: src/pages/settings.jsx:600
msgid "Server-side grouped notifications"
msgstr "Notificações agrupadas do servidor"

#: src/pages/settings.jsx:604
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Recurso em estágio Alpha. Janela potencialmente agrupada e melhorada, porém lógica básica de agrupamento."

#: src/pages/settings.jsx:625
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Opções de exportação/importação \"nuvem\" para atalhos"

#: src/pages/settings.jsx:630
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Muito experimental.<0/>Armazenado nas notas do seu perfil. Notas (privadas) do perfil são mais usadas para outros perfis, e oculto para o próprio perfil."

#: src/pages/settings.jsx:641
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Nota: Este recurso usa a API do servidor de instância atualmente registrado."

#: src/pages/settings.jsx:658
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Modo oculto <0>(<1>Texto</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:667
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Substituir os textos por blocos, útil ao fazer capturas de tela, por razões de privacidade."

#: src/pages/settings.jsx:692
msgid "About"
msgstr "Sobre"

#: src/pages/settings.jsx:731
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Feito</0> por <1>@cheeaun</1>"

#: src/pages/settings.jsx:760
msgid "Sponsor"
msgstr "Patrocínio"

#: src/pages/settings.jsx:768
msgid "Donate"
msgstr "Doar"

#: src/pages/settings.jsx:776
msgid "Privacy Policy"
msgstr "Política de privacidade"

#: src/pages/settings.jsx:783
msgid "<0>Site:</0> {0}"
msgstr "<0>Site:</0> {0}"

#: src/pages/settings.jsx:790
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versão:</0> <1/> {0}"

#: src/pages/settings.jsx:805
msgid "Version string copied"
msgstr "Versão copiada"

#: src/pages/settings.jsx:808
msgid "Unable to copy version string"
msgstr "Não foi possível copiar versão"

#: src/pages/settings.jsx:933
#: src/pages/settings.jsx:938
msgid "Failed to update subscription. Please try again."
msgstr "Falhou ao atualizar inscrição. Tente novamente."

#: src/pages/settings.jsx:944
msgid "Failed to remove subscription. Please try again."
msgstr "Falhou ao remover inscrição. Tente novamente."

#: src/pages/settings.jsx:951
msgid "Push Notifications (beta)"
msgstr "Notificações de push (beta)"

#: src/pages/settings.jsx:973
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "As notificações de push estão bloqueadas. Por favor, ative-as nas opções do navegador."

#: src/pages/settings.jsx:982
msgid "Allow from <0>{0}</0>"
msgstr "Permitir de <0>{0}</0>"

#: src/pages/settings.jsx:991
msgid "anyone"
msgstr "qualquer um"

#: src/pages/settings.jsx:995
msgid "people I follow"
msgstr "pessoas que sigo"

#: src/pages/settings.jsx:999
msgid "followers"
msgstr "seguidores"

#: src/pages/settings.jsx:1032
msgid "Follows"
msgstr "Seguindo"

#: src/pages/settings.jsx:1040
msgid "Polls"
msgstr "Enquetes"

#: src/pages/settings.jsx:1044
msgid "Post edits"
msgstr "Edições de publicação"

#: src/pages/settings.jsx:1065
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "A permissão de push não foi concedida desde a última sessão. Você precisa <0><1>iniciar sessão</1> novamente para conceder permissão</0>."

#: src/pages/settings.jsx:1081
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTA: Notificações de push só funcionam para <0>uma conta</0>."

#: src/pages/status.jsx:565
msgid "Post"
msgstr "Publicar"

#: src/pages/status.jsx:786
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Você não está conectado. Interações como (respostas, impulsos, etc.) não são possíveis."

#: src/pages/status.jsx:799
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Essa publicação é de outra instância (<0>{instance}</0>). Interações como (respostas, impulsos, etc.) não são possíveis."

#: src/pages/status.jsx:827
msgid "Error: {e}"
msgstr "Erro: {e}"

#: src/pages/status.jsx:834
msgid "Switch to my instance to enable interactions"
msgstr "Alterar para minha instância para ativar interações"

#: src/pages/status.jsx:936
msgid "Unable to load replies."
msgstr "Não foi possível carregar respostas."

#: src/pages/status.jsx:1048
msgid "Back"
msgstr "Voltar"

#: src/pages/status.jsx:1079
msgid "Go to main post"
msgstr "Ir para à publicação principal"

#: src/pages/status.jsx:1102
msgid "{0} posts above ‒ Go to top"
msgstr "{0} publicações acima – Voltar ao topo"

#: src/pages/status.jsx:1145
#: src/pages/status.jsx:1208
msgid "Switch to Side Peek view"
msgstr "Alterar para vista lateral"

#: src/pages/status.jsx:1209
msgid "Switch to Full view"
msgstr "Alterar para vista completa"

#: src/pages/status.jsx:1227
msgid "Show all sensitive content"
msgstr "Mostrar conteúdo sensível"

#: src/pages/status.jsx:1232
msgid "Experimental"
msgstr "Experimental"

#: src/pages/status.jsx:1241
msgid "Unable to switch"
msgstr "Não foi possível alterar"

#: src/pages/status.jsx:1248
msgid "Switch to post's instance ({0})"
msgstr "Alterar para instância da publicação ({0})"

#: src/pages/status.jsx:1251
msgid "Switch to post's instance"
msgstr "Alterar para instância da publicação"

#: src/pages/status.jsx:1309
msgid "Unable to load post"
msgstr "Não foi possível carregar publicação"

#: src/pages/status.jsx:1426
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# resposta} other {<0>{1}</0> respostas}}"

#: src/pages/status.jsx:1444
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# comentário} other {<0>{0}</0> comentários}}"

#: src/pages/status.jsx:1466
msgid "View post with its replies"
msgstr "Ver publicação com respostas"

#: src/pages/trending.jsx:70
msgid "Trending ({instance})"
msgstr "Tendência ({instance})"

#: src/pages/trending.jsx:227
msgid "Trending News"
msgstr "Novidades"

#: src/pages/trending.jsx:374
msgid "Back to showing trending posts"
msgstr "Voltar a mostrar publicações em tendência"

#: src/pages/trending.jsx:379
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Mostrar publicações mencionando <0>{0}</0>"

#: src/pages/trending.jsx:391
msgid "Trending posts"
msgstr "Publicações em tendência"

#: src/pages/trending.jsx:414
msgid "No trending posts."
msgstr "Nenhuma publicação em tendência."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Um cliente web para Mastodon minimalista e original."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Iniciar sessão com Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Iniciar sessão"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Conecte com sua conta existente do Mastodon/Fediverse.<0/>Os seus credenciais não serão armazenados neste servidor."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Feito</0> por <1>@cheeaun</1>. <2>Política de privacidade</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Captura de tela do carrossel de impulsos"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Carrossel de impulsos"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Separa visualmente as publicações originais das compartilhadas (publicações impulsionadas)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Captura de tela de tópicos de comentários aninhados"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Tópico de comentários aninhados"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Siga facilmente as conversas. Respostas semi-colapsáveis."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Captura de tela de notificações agrupadas"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Notificações agrupadas"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Notificações similares são agrupadas e contraídas para evitar desordem."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Captura de tela do UI multi-coluna"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Única ou multi-coluna"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Por padrão, uma única coluna para amantes do modo zen. Multi-coluna configurável para usuários atacantes."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Captura de tela da linha de tempo multi-hashtag com uma forma de adicionar mais hashtags"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Linha de tempo multi-hashtag"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Até 5 hashtags combinadas em uma única linha do tempo."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Parece que o seu navegador está bloqueando pop-ups."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Uma publicação rascunho está atualmente minimizada. Publique-a ou a descarte antes de criar uma."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Uma publicação está atualmente aberta. Publique-a ou a descarte antes de criar uma."

